import axios, { AxiosError, AxiosResponse } from "axios";

const client = axios.create({
  baseURL: process.env.VUE_APP_API_URL,
});

export const http = client;

export type IHttpErrorResponse = AxiosResponse & AxiosError;
